import { createI18n } from "vue-i18n";

import en from "@/locales/en.json";
import ro from "@/locales/ro.json";
import de from "@/locales/de.json";
import hu from "@/locales/hu.json";
import fr from "@/locales/fr.json";

export const i18n = createI18n({
  locale: "en",
  messages: { en, ro, de, hu, fr },
});